import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCategoryOpen, setIsCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
    setIsCategoryOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-[1400px] mx-auto">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer group"
          >
            <span className="font-heading text-xl md:text-2xl font-bold text-primary-500 group-hover:text-primary-600 transition-colors">
              古风漫画网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm font-medium rounded-md transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? 'text-primary-500 bg-primary-50'
                  : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50'
              }`}
            >
              首页
            </Link>

            <div
              className="relative"
              onMouseEnter={() => setIsCategoryOpen(true)}
              onMouseLeave={() => setIsCategoryOpen(false)}
            >
              <button
                className={`px-4 py-2 text-sm font-medium rounded-md transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1 ${
                  location.pathname.startsWith('/category')
                    ? 'text-primary-500 bg-primary-50'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50'
                }`}
              >
                分类浏览
                <i className={`ri-arrow-down-s-line text-sm transition-transform ${isCategoryOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {isCategoryOpen && (
                <div className="absolute top-full left-0 mt-1 w-48 bg-background-50 rounded-lg shadow-lg border border-background-200 py-2 z-50">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="block px-4 py-2.5 text-sm text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {cat.name}
                      <span className="text-foreground-400 text-xs ml-2">({cat.count})</span>
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`px-4 py-2 text-sm font-medium rounded-md transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'text-primary-500 bg-primary-50'
                  : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-foreground-700 hover:text-primary-500 transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden border-t border-background-200 bg-background-50">
            <div className="flex flex-col py-2 px-4 max-w-[1400px] mx-auto">
              <Link
                to="/"
                className="py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer border-b border-background-100"
              >
                首页
              </Link>
              <div className="py-2 border-b border-background-100">
                <p className="py-2 text-sm font-medium text-foreground-500">分类浏览</p>
                <div className="grid grid-cols-2 gap-1">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="py-2 text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  ))}
                </div>
              </div>
              <Link
                to="/about"
                className="py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer border-b border-background-100"
              >
                关于我们
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}